import type { AssignmentIntervalPage } from "../web-client/api/data-contracts";
import * as operations from "../web-client/api/operations";
import type { Transport } from "../web-client/transport";

/**
 * One read of a workspace's assignment records: history mode for those overlapping `[from, to]`, or delta mode for
 * those opened or closed by a transition written after `since`. The server serves neither mode past 31 days.
 */
export type AssignmentIntervalQuery = { workspaceId: string } & ({ from: string; to: string } | { since: string });

/** Reads a workspace's driver-on-vehicle assignment records in one mode. */
export function listAssignmentIntervals(
  transport: Transport,
  query: AssignmentIntervalQuery,
): Promise<AssignmentIntervalPage> {
  return operations.getWorkspacesAssignmentIntervals(transport, query);
}
